import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-corporate-cards-cmb-v2.component.scss';
var FormItemBusinessCorporateCardsCmbV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessCorporateCardsCmbV2, _super);
    function FormItemBusinessCorporateCardsCmbV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessCorporateCardsCmbV2.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-business-corporate-cards-cmb__button');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
    };
    FormItemBusinessCorporateCardsCmbV2.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".form__input--busReg");
        if (businessReg) {
            businessReg.addEventListener("input", function (event) {
                if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                    var reg = event.target.value;
                    event.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (event) {
                var reg = event.target.value;
                event.target.value = _this.validationService.formatExpression(reg);
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
    };
    FormItemBusinessCorporateCardsCmbV2.prototype.submitForm = function (pForm) {
        var _this = this;
        var _email = this.form.querySelector("input[name=email]");
        var _recipient = this.form.querySelector("input[name=recipient]");
        var _subject = this.form.querySelector("input[name=subject]");
        var _product = this.form.querySelector("input[name=product]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _contact = this.form.querySelector("input[name=contact-number]");
        var _busName = this.form.querySelector("input[name=business-name]");
        var _busRegNumber = this.form.querySelector("input[name=business-reg-number]");
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _dateTime = "Anytime";
        if (_date && _time) {
            if (_time.value !== "Anytime") {
                _dateTime = _date.value + " " + _time.value;
            }
        }
        var _postData = {
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'product': (_product ? _product.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'firstName': (_firstname ? _firstname.value : ""),
            'surname': (_lastName ? _lastName.value : ""),
            'contactNumber': (_contact ? _contact.value : ""),
            'businessName': (_busName ? _busName.value : ""),
            'businessRegNumber': (_busRegNumber ? _busRegNumber.value : ""),
            'popiConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dateTime': _dateTime
        };
        this.showDisplayView("loader");
        // service
        var url = this.baseUrl + "/leadsutils/save-company-card-lead";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (response) {
            if (response.data.includes("invalid")) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", "200");
                _this.showDisplayView("success");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessCorporateCardsCmbV2.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemBusinessCorporateCardsCmbV2;
}(Base));
export { FormItemBusinessCorporateCardsCmbV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-corporate-cards-cmb-v2/form-item-business-corporate-cards-cmb-v2.component.ts
// module id = 887
// module chunks = 0